module.exports = __webpack_public_path__ + "static/media/SF-1-A.538e65e7.mp3";